const theme = {
  black: "#000000",
  white: "#FFFFFF",
  lightGrey: "#A9A9A9",
  lightGrey2: "#C7C7C7",
  lightGrey3: "#959595",
  red: "#DD5343",
}

export default theme
